export default "__VITE_ASSET__DALeY0kH__"